




























































































import Vue from "vue";

export default Vue.extend({
  name: "InvoiceRecurringReportDetailField",

  props: {
    loadingDetail: {
      type: Boolean,
      default: false,
    },
    detailData: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    columnsTableDetail() {
      return [
        {
          title: this.$t("lbl_unit"),
          dataIndex: "unit",
          key: "unit",
          width: 25,
          scopedSlots: { customRender: "isNull" },
        },
        {
          title: this.$t("lbl_description"),
          dataIndex: "description",
          key: "description",
          width: 100,
          scopedSlots: { customRender: "isNull" },
        },
        {
          title: this.$t("lbl_qty"),
          dataIndex: "qty",
          key: "qty",
          width: 75,
          scopedSlots: { customRender: "isCurrency" },
        },
        {
          title: this.$t("lbl_price"),
          dataIndex: "price",
          key: "price",
          width: 75,
          scopedSlots: { customRender: "isCurrency" },
        },
        {
          title: this.$t("lbl_total"),
          dataIndex: "subtotal",
          key: "subtotal",
          width: 75,
          scopedSlots: { customRender: "isCurrency" },
        },
      ];
    },
  },
});
